<h2 mat-dialog-title class="confirm-dialog__title">
  {{ data.title }}
</h2>

<mat-dialog-content class="confirm-dialog__content">
  <p>{{ data.message }}</p>

  <mat-checkbox [(ngModel)]="understood"> I understand </mat-checkbox>
</mat-dialog-content>

<mat-dialog-actions align="end" class="confirm-dialog__actions">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!understood" (click)="onProceed()">Proceed</button>
</mat-dialog-actions>
